import styled from 'styled-components'

import type { LineProps } from './Line.types'

const StLine = styled.div<LineProps>`
  ${({ theme, thickness, isVertical, color }) => {
    return `
      height: ${isVertical ? '100%' : 'auto'};
      border-top: ${isVertical ? '' : `${thickness || 1}px solid ${color || theme.Components.Card.Border}`};
      border-left: ${isVertical ? `${thickness || 1}px solid ${color || theme.Components.Card.Border}` : ''};
    `
  }}
`

export { StLine }
